import axios from "axios";

export const fetchFriends = async () => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/friend/list`, {withCredentials: true})).data
}

export const fetchFriendRequests = async () => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/friend/list-invites`, {withCredentials: true})).data
}

export const fetchFriendStatus = async (potentialFriendName) => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/friend/is-friend/${potentialFriendName}`, {withCredentials: true})).data
}

export const sendFriendRequest = async (friendName) => {
    return (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/friend/send-request`, {friendName: friendName}, {withCredentials: true}))
}

export const handleFriendRequest = async (inviterId, accepted) => {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/friend/handle-request`, {inviterId: inviterId, accepted: accepted}, {withCredentials: true})
}

export const fetchFriendMessages = async (friendName, pageNo) => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/friend/messages/${friendName}?pageNo=${pageNo}`, {withCredentials: true})).data;
}